import {
    COOKIE_EXPIRATION_DAYS,
    COOKIE_VISITOR_ID,
} from '@marketplace/config/cookie.js'
import Cookies from 'js-cookie'
import { validate as uuidValidate } from 'uuid'

/**
 * Update the visit cookie when changing pages so the cookie lifetime is extended.
 * If visitorId is present in URL parameters, use that instead of existing cookie.
 *
 * @param {object} context
 */
export default function (context) {
    const urlVisitorId = context.route.query.visitorId
    const cookieVisitorId = Cookies.get(COOKIE_VISITOR_ID)

    // If URL has visitorId and it's a valid UUID, use it (overriding any existing cookie)
    if (urlVisitorId && uuidValidate(urlVisitorId)) {
        Cookies.set(COOKIE_VISITOR_ID, urlVisitorId, {
            expires: COOKIE_EXPIRATION_DAYS.ONE_YEAR,
            path: '/', // Specifically set the path because the defaults aren't used when updating a cookie
            domain: context.$config.cookieUrl,
        })
    }
    // Otherwise extend existing cookie if present
    else if (cookieVisitorId) {
        Cookies.set(COOKIE_VISITOR_ID, cookieVisitorId, {
            expires: COOKIE_EXPIRATION_DAYS.ONE_YEAR,
            path: '/', // Specifically set the path because the defaults aren't used when updating a cookie
            domain: context.$config.cookieUrl,
        })
    }
}
